export default "__VITE_ASSET__DfV1CadU__"